import { render, staticRenderFns } from "./CallOut.vue?vue&type=template&id=a82e061c&scoped=true"
import script from "./CallOut.vue?vue&type=script&lang=js"
export * from "./CallOut.vue?vue&type=script&lang=js"
import style0 from "./CallOut.vue?vue&type=style&index=0&id=a82e061c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82e061c",
  null
  
)

export default component.exports